
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import Paie from '@/extend/classes/Paie';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storePaie' })

export default class storePaie extends VuexModule {
  // States
  private reccords: Paie[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get paieLoading (): boolean {
    return this.dataLoading;
  }
  private get paieRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get paieLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewPaie() {
    return (): Paie => { 
      return this.getPaie(0, true);
    }
  }

  
  public get getPaie () {
    return (id: number, canCreate = false): Paie => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id Paie can't be 0")
        return new Paie();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new Paie();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            Paie.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromPaie(data.reccords[0] as Paie);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listPaie (): Paie[] {
    return this.reccords;
  }

  public get listConfigPaie (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mPaieRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mPaieClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mPaieLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mPaieLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(Paie.fromJson(reccord as Paie));
    })
    Paie.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mPaieConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mPaieCreated (obj: Paie): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.comparePaie(obj)) {
          api.fromPaie(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.comparePaie(obj)) {
            api.fromPaie(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mPaieUpdated (obj: Paie): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.comparePaie(obj)) {
          api.fromPaie(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mPaieDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerPaie (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.paieRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerPaie(this.paieCreated, this.paieUpdated, this.paieDeleted);
          this.mPaieRegistered();
        } else {
          setTimeout(() => resolve(this.registerPaie(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.paieLoading && !this.paieLoaded) {
          this.mPaieLoading(true);
          return Paie.list(filter)
            .then((data: ListData) => {
              this.mPaieLoaded(data);
              this.mPaieLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredPaie (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.paieLoading) {
        this.mPaieLoading(true);
        return Paie.list(filter)
          .then((data: ListData) => {
            this.mPaieLoaded(data);
            this.mPaieLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createPaie (obj: Paie): Promise<Paie> {
    return new Promise((resolve, reject) => {
      return Paie.fromJson(obj).createForStorePaie()
        .then((reccords) => {
          this.mPaieCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  public updatePaie (obj: Paie): Promise<Paie> {
    return new Promise((resolve, reject) => {
      return Paie.fromJson(obj).updateForStorePaie()
        .then((reccords) => {
          this.mPaieUpdated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }
  
  @Action
  public deletePaie (obj: Paie): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return Paie.fromJson(obj).deleteForStorePaie()
        .then(() => {
          if (!storeSession.hubUsed) {
            this.mPaieDeleted(obj.id);
          }
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  private paieCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mPaieConfigUpdated(config)
    const obj = objConfig.obj as Paie;
    this.mPaieCreated(Paie.fromJson(obj));
  }

  @Action
  private paieUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mPaieConfigUpdated(config)
    const obj = objConfig.obj as Paie;
    this.mPaieUpdated(Paie.fromJson(obj));
  }

  @Action
  private paieDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as Paie;
    this.mPaieDeleted(obj.id);
  }
}
